import matestackEventHub from '../event_hub';
var transitionHandlingMixin = {
  methods: {
    successTransitionHandling: function successTransitionHandling(response) {
      var self = this;

      if (self.props["success"] != undefined && self.props["success"]["transition"] != undefined && (self.props["success"]["transition"]["follow_response"] == undefined || self.props["success"]["transition"]["follow_response"] === false) && self.appNavigateTo != undefined) {
        var path = self.props["success"]["transition"]["path"];
        self.appNavigateTo({
          url: path,
          backwards: false
        });
        return;
      }

      if (self.props["success"] != undefined && self.props["success"]["transition"] != undefined && self.props["success"]["transition"]["follow_response"] === true && self.appNavigateTo != undefined) {
        var _path = response.data["transition_to"] || response.request.responseURL;

        self.appNavigateTo({
          url: _path,
          backwards: false
        });
        return;
      } // redirect handling


      if (self.props["success"] != undefined && self.props["success"]["redirect"] != undefined && (self.props["success"]["redirect"]["follow_response"] == undefined || self.props["success"]["redirect"]["follow_response"] === false)) {
        var _path2 = self.props["success"]["redirect"]["path"];
        window.location.href = _path2;
        return;
      }

      if (self.props["success"] != undefined && self.props["success"]["redirect"] != undefined && self.props["success"]["redirect"]["follow_response"] === true) {
        var _path3 = response.data["redirect_to"] || response.request.responseURL;

        window.location.href = _path3;
        return;
      }
    },
    failureTransitionHandling: function failureTransitionHandling(error) {
      var self = this;

      if (self.props["failure"] != undefined && self.props["failure"]["transition"] != undefined && (self.props["failure"]["transition"]["follow_response"] == undefined || self.props["failure"]["transition"]["follow_response"] === false) && self.appNavigateTo != undefined) {
        var path = self.props["failure"]["transition"]["path"];
        self.appNavigateTo({
          url: path,
          backwards: false
        });
        return;
      }

      if (self.props["failure"] != undefined && self.props["failure"]["transition"] != undefined && self.props["failure"]["transition"]["follow_response"] === true && self.appNavigateTo != undefined) {
        var _path4 = error.response.data["transition_to"] || response.request.responseURL;

        self.appNavigateTo({
          url: _path4,
          backwards: false
        });
        return;
      } // redirect handling


      if (self.props["failure"] != undefined && self.props["failure"]["redirect"] != undefined && (self.props["failure"]["redirect"]["follow_response"] == undefined || self.props["failure"]["redirect"]["follow_response"] === false)) {
        var _path5 = self.props["failure"]["redirect"]["path"];
        window.location.href = _path5;
        return;
      }

      if (self.props["failure"] != undefined && self.props["failure"]["redirect"] != undefined && self.props["failure"]["redirect"]["follow_response"] === true) {
        var _path6 = error.response.data["redirect_to"] || response.request.responseURL;

        window.location.href = _path6;
        return;
      }
    }
  }
};
export default transitionHandlingMixin;